import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { compose, withState, withHandlers } from "recompose";

import * as actions from '../actions';
import { notify } from "../../../components/libs/notification";

import NewEditReport from './NewEditReport'

import {getFilterCountries} from "../../../utils/globalSelectors";

const enhance = compose(
  withState("isDeleteDialogOpen", "toggleDelete", false),
  withHandlers({
    toggleDeleteDialog: props => () =>
      props.toggleDelete(isDeleteDialogOpen => !isDeleteDialogOpen),
  })
)

const mapStateToProps = (state, ownProps) => {
  const reportCategory = ownProps.params.category;
  const reportId = ownProps.params.id;

  const {
    businessReportId,
    countryCode,
    countryName,
    companyCode,
    companyCodeName,
    reports,
    reportName,
    reportDescription,
    fetchingReports,
    fetchingReportFields,
  } = state.reports

  return {
    countries: getFilterCountries(state),
    countryCode,
    countryName,
    companyCode,
    companyCodeName,
    businessReportId,
    reportId,
    reportCategory,
    reportName,
    reportDescription,
    reports,
    fetchingReports,
    fetchingReportFields,
  }
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  notify: bindActionCreators(notify, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(
  enhance(NewEditReport)
);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/report-edit/NewEditReportContainer.js